// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"bf4810b3","787":"04e9e330"}[chunkId] + ".chunk.js";
};